import debug from 'debug';
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
// import createHistory from 'history/createMemoryHistory';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { connectRoutes } from 'redux-first-router';
import restoreScroll from 'redux-first-router-restore-scroll'
import thunkMiddleware from 'redux-thunk';
import { nprogress, nprogressMiddleware } from 'redux-nprogress';
import { createResponsiveStoreEnhancer } from 'redux-responsive';
// TODO: implement using pino
import logger from 'redux-logger';
import querySerializer from '../lib/query-serializer';
import storeReducers from './reducers/index';
import browserReducer from './reducers/browser';
import * as actionCreators from './actions';
import inject from './middleware/inject';
// import routeConfig from '../app/routes';
import routeConfig from '../app/routes.global';

const log = debug('huddle:store:configure');

// logger middleware can become very verbose so only if it's desired
const ADD_LOGGER_MIDDLEWARE = (process.env.NODE_ENV === 'development')
  // mock the DEBUG env var check for the logger middleware to redux store
  && process.env.DEBUG
  // Probably a better test or way to check this
  // - b/c this will fail DEBUG=-huddle:store:*,huddle:store:middleware:*
  // - (which I can't remember if this should work or not)
  // - no more time to spend on this trivial thing
  && !/-huddle:(\*|store:(\*|middleware:(\*|logger)))/i.test(process.env.DEBUG)
  && /huddle:(\*|store:(\*|middleware:(\*|logger)))/i.test(process.env.DEBUG);

const routeOptions = {
  querySerializer,
  restoreScroll: restoreScroll(),
};
const devToolsOptions = {
  actionCreators,
};

function composeEnhancers(...args) {
  return typeof window !== 'undefined'
    // use this line to pass options to composeWithDevTools
    ? composeWithDevTools(devToolsOptions)(...args)
    : compose(...args);
}

export default function configureStore(history, initialState, dependencyOpts = {}) {
  const {
    reducer: routeReducer,
    middleware: routeMiddleware,
    enhancer: routeEnhancer,
    thunk: routeThunk,
  } = connectRoutes(history, routeConfig, routeOptions);

  // pull out the breakpoint calculated by detection server middleware
  const {
    breakpoint,
    ...bootstrapState
  } = initialState;

  const rootReducer = combineReducers({
    ...storeReducers,
    nprogress,
    location: routeReducer,
    browser: browserReducer(breakpoint),
  });
  const middlewares = [
    routeMiddleware,
    thunkMiddleware.withExtraArgument(inject(dependencyOpts)),
    nprogressMiddleware(),
  ];
  if (ADD_LOGGER_MIDDLEWARE) {
    middlewares.push(logger);
  }
  const appliedMiddleware = applyMiddleware(...middlewares);

  const enhancers = composeEnhancers(
    routeEnhancer,
    createResponsiveStoreEnhancer({ calculateInitialState: false }),
    appliedMiddleware,
  );

  const store = createStore(rootReducer, bootstrapState, enhancers);

  if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('./reducers/index', () => {
      const reducers = require('./reducers/index'); // eslint-disable-line global-require
      const updatedRootReducer = combineReducers({ ...reducers, location: routeReducer });
      store.replaceReducer(updatedRootReducer);
    });
  }

  // log('store:', store);
  // log('routeThunk:', routeThunk);
  return { store, routeThunk };
}



// WEBPACK FOOTER //
// ./src/store/configure.js